import { CLASS_NAME } from 'constants/class-names'

export const isComparisonResults = (): boolean => {
    return !!document.querySelector(`.${CLASS_NAME.page.comparisonResults}`)
}

export const isFindCompare = (): boolean => {
    return !!document.querySelector(`.${CLASS_NAME.page.findCompare}`)
}
